import tracker from './default-tracker';

/**
 * @deprecated create a tracker with 'createTracker' instead
 */
export default tracker;

/**
 * Creates an instance of the tracker
 * @param validatedOptions the configuration to be used
 * @returns the tracker
 */
export { default as createTracker } from './tracker';

/**
 * Identifies the user of this session
 * @deprecated create a tracker with 'createTracker' and use that for tracking
 */
export const identify = tracker.identify;

/**
 * Tracks a page
 * @deprecated create a tracker with 'createTracker' and use that for tracking
 */
export const page = tracker.page;

/**
 * Enable the listener
 * @deprecated enables the listener used for attribute tracking
 */
export const listen = tracker.listen;

/**
 * Initializes the default tracker
 * @param validatedOptions the configuration to be used
 * @deprecated use 'createTracker' instead
 */
export const initialize = tracker.initialize;

export { Environment, EnvironmentOptions, EventData, ListenerOptions, Logger, OpCo, Page, Tracker, User } from './types';

export { getAttributeData, toAttributeData } from './listener';
